export const userConstants = {
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_TOKEN_RECEIVED: "LOGIN_TOKEN_RECEIVED",

  LOGOUT: "USERS_LOGOUT",
  
  RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",
  RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
};



// WEBPACK FOOTER //
// ./src/constants/user.constants.tsx